// replace the change history link's container with the actual change history
$(document).on('ajax:success', 'a[data-action="history"]', function (e) {
  var html = e.detail[0];
  $(e.target).closest('div.history').html(html.body);
});
